import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const exportDataReducer = createReducer(initialState, {
  FETCH_EXPORT_DATA_REQUEST: (state) => {
    state.loading = true;
    state.error = null;
  },
  FETCH_EXPORT_DATA_SUCCESS: (state, action) => {
    console.log("DEBUG: Export data fetched successfully", action.payload);
    state.loading = false;
    state.data = action.payload; // <-- directly assign payload
    state.error = null;
  },
  FETCH_EXPORT_DATA_FAILURE: (state, action) => {
    state.loading = false;
    state.data = null;
    state.error = action.payload;
  },
});



export default exportDataReducer;
